export default __webpack_public_path__ + "images/b6db15d0d30fe990eff57d8c130f8ea7-newyearseve.jpg";